import {
	JSONLocationSuggestion,
	SUGGESTION_TYPES,
} from "../../../data/models/JSONLocationSuggestion";
import { GroupedAutoSuggestion } from "../../../components/VeBoxAutoSuggest/types";
import { AutoSuggestionItemProps } from "@vebox/etui-core";
import { VeBoxEquipmentFilters } from "../../../data/models/VeBoxEquipmentFilters";

export const mapLocationAndGroupedByTypes = (
	suggestions: JSONLocationSuggestion[],
): GroupedAutoSuggestion[] => {
	const mappedSuggestions: GroupedAutoSuggestion[] = [];
	suggestions.forEach((suggestion) => {
		const autoSuggestion = {
			label: suggestion?.name,
			value: suggestion?.guid,
			type: suggestion?.type,
			localizedType: suggestion?.localizedType,
		};
		const suggestionType = suggestion.localizedType;
		const suggestionIndex = mappedSuggestions.findIndex(
			(suggestion) => suggestion.groupName === suggestionType,
		);
		if (suggestionIndex === -1) {
			mappedSuggestions.push({
				groupName: suggestion.localizedType,
				suggestions: [autoSuggestion],
			});
		} else {
			mappedSuggestions[suggestionIndex].suggestions.push(autoSuggestion);
		}
	});
	return mappedSuggestions;
};

export const createSiteFilter = (
	selectedSite: AutoSuggestionItemProps & {
		type?: SUGGESTION_TYPES;
	},
): VeBoxEquipmentFilters => {
	const filter: VeBoxEquipmentFilters = {};
	switch (selectedSite?.type) {
		case SUGGESTION_TYPES.COUNTRY:
			filter.locationFiltersCategory = { countryGuid: selectedSite?.value };
			break;
		case SUGGESTION_TYPES.REGION:
			filter.locationFiltersCategory = { regionGuid: selectedSite?.value };
			break;
		case SUGGESTION_TYPES.PROVINCE:
			filter.locationFiltersCategory = { provinceGuid: selectedSite?.value };
			break;
		case SUGGESTION_TYPES.CITY:
			filter.locationFiltersCategory = { cityGuid: selectedSite?.value };
			break;
		case SUGGESTION_TYPES.ZIP_CODE:
			filter.locationFiltersCategory = { genericName: selectedSite?.label };
			break;
		case SUGGESTION_TYPES.LOCATION:
			filter.locationFiltersCategory = { locationGuid: selectedSite?.value };
			break;
		case SUGGESTION_TYPES.ADDRESS:
			filter.locationFiltersCategory = { addressGuid: selectedSite?.value };
			break;
	}
	return filter;
};
